export const WALLETTO_IDS = ['28', '57', '67', '68', '69', '70', '73', '99', '142']
